<template>
  <div class="create-date-action">
    <div class="action-item">
      <el-button
        class="button-block"
        :disabled="isTodaySelected"
        @click="setToday"
        >今日の日付を入力</el-button
      >
    </div>
    <div class="action-item">
      <el-button
        class="button-block"
        :disabled="isTomorrowSelected"
        @click="setTomorrow"
        >明日の日付を入力</el-button
      >
    </div>
    <div class="action-item">
      <el-date-picker
        :value="value"
        type="date"
        :clearable="false"
        placeholder="選択してください"
        :format="'yyyy年M月d日'"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'

const props = defineProps<{
  value?: Date | string | null
}>()

const emit = defineEmits<{
  (e: 'input', value: Date): void
}>()

type DateFormLib = {
  dateWithoutTime: (date: Date | string | null | undefined) => number | string
  getToday: () => Date
  getTommorow: () => Date
}

const { formLib: formLibRaw } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & DateFormLib

const isTodaySelected = computed(
  () =>
    formLib.dateWithoutTime(props.value) ===
    formLib.dateWithoutTime(formLib.getToday())
)

const isTomorrowSelected = computed(
  () =>
    formLib.dateWithoutTime(props.value) ===
    formLib.dateWithoutTime(formLib.getTommorow())
)

function setToday() {
  emit('input', formLib.getToday())
}

function setTomorrow() {
  emit('input', formLib.getTommorow())
}

function onInput(next: Date) {
  emit('input', next)
}
</script>
